<template>
      <span  style="text-align:left">
        <template v-if="modo=='new'||modo=='edit'||modo=='flow'">

        </template>


        <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
          <span :class="{'text-xs-center':crud.action=='list'}" v-html="displayvalue.replace(/\n/g, '<br/>')"></span>
        </template>        
      </span>
</template>
    

<script>

try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
import _  from 'lodash';
export default {
  extends:_baseComponent,

  data() {
    return {
    };
  },
  methods: {
    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },    
  },

};
</script>

<style scoped>

</style>

    